import { render, staticRenderFns } from "./StudentstatisticsLess.vue?vue&type=template&id=1b369e84"
import script from "./StudentstatisticsLess.vue?vue&type=script&lang=js"
export * from "./StudentstatisticsLess.vue?vue&type=script&lang=js"
import style0 from "./StudentstatisticsLess.vue?vue&type=style&index=0&id=1b369e84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports